// "Business · why?" -- the business-use affordance, tokened on
// --business-surface / --business-foreground, never a raw hex (§2.2). The
// optional "why?" opens the rule that tagged it, per the design's account
// row disclosure ("Tagged business because: Condition ... · on · all of 2026").
import { Badge } from '@moneyskyline/ui';

export function BusinessChip({
  reason,
  onWhy,
  className,
}: {
  reason?: string;
  onWhy?: () => void;
  className?: string;
}) {
  return (
    <Badge
      variant="secondary"
      className={['inline-flex items-center gap-1.5 rounded-full bg-business-surface font-normal text-business-foreground', className]
        .filter(Boolean)
        .join(' ')}
      data-testid="business-chip"
    >
      Business
      {onWhy && (
        <button
          type="button"
          onClick={onWhy}
          className="text-business underline decoration-dotted"
          aria-label={reason ? `Why business: ${reason}` : 'Why business?'}
        >
          · why?
        </button>
      )}
    </Badge>
  );
}

export default BusinessChip;
